const Index = (resolve) =>
  require.ensure([], () => resolve(require("./Index.vue")), "admin-orgs");
const Show = (resolve) =>
  require.ensure([], () => resolve(require("./Show.vue")), "admin-orgs");

export default [
  {
    path: "/admin/stat/orgs",
    name: "/admin/stat/orgs",
    component: Index,
    meta: {
      title: "各教指委比赛/培训情况统计",
      layout: "admin",
    },
  },
  {
    path: "/admin/stat/orgs/:org_id",
    name: "/admin/stat/orgs/show",
    component: Show,
    meta: {
      title: "各教指委比赛/培训情况统计",
      layout: "admin",
    },
  },
];



// WEBPACK FOOTER //
// ./src/pages/admin/stat/orgs/index.js